// ══════════════════════════════════════════════════════════════════════════════
//  src/profesiones.js
//  A QUÉ SE DEDICA LA GENTE QUE ENTRENA EN NSL
//
//  Rob, 23-09-2026, con la pantalla delante: «está mal porque estamos limitando
//  a esas opciones».
//
//  La pantalla ofrecía cinco: Estudiante, Arquitecto, Desarrollador, Diseñador
//  y Empleado de oficina. Cuatro de las cinco son de oficina o de tecnología, y
//  quien es enfermera, mesero o transportista no se veía en ninguna — así que la
//  lista no ayudaba a contestar, decía «esto no es para ti».
//
//  Estas sugerencias son ATAJOS, no el menú: la caja de texto de al lado admite
//  cualquier cosa, y es la que manda. Por eso la lista puede crecer sin miedo y
//  tampoco pasa nada si a alguien le falta la suya.
//
//  El orden es el de la pantalla: las diez primeras se ven de entrada y el resto
//  aparece al tocar «Ver más». Si añades una, ponla donde toque por frecuencia,
//  no al final.
// ══════════════════════════════════════════════════════════════════════════════

export const PROFESIONES = [
    'Estudiante',
    'Empleado de oficina',
    'Ventas o comercial',
    'Atención a clientes',
    'Docente o maestro',
    'Ingeniero',
    'Desarrollador',
    'Diseñador',
    'Administración',
    'Negocio propio',
    // ── A partir de aquí, al tocar «Ver más» ──────────────────────────────
    'Contador o finanzas',
    'Marketing',
    'Recursos humanos',
    'Médico o enfermería',
    'Abogado',
    'Arquitecto',
    'Turismo u hotelería',
    'Chef o cocina',
    'Operaciones o logística',
    'Transporte',
    'Construcción u oficios',
    'Ama de casa',
    'Jubilado',
    'Buscando trabajo',
];

// Cuántas se enseñan antes de tocar «Ver más». Diez caben en tres filas sin
// tapar el botón de continuar, que es lo que el alumno tiene que ver.
export const PROFESIONES_A_LA_VISTA = 10;
